module.exports = __webpack_public_path__ + "img/company_part1bg_m.ed96f80c.jpg";